var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderExpedited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1548 3.89041C7.26629 3.65291 7.51475 3.5 7.79004 3.5H13.2801C13.7963 3.5 14.1329 4.01404 13.9016 4.4513L12.8474 7.40411H14.6511C15.2705 7.40411 15.5802 8.11206 15.1425 8.52589L7.51885 16.5C6.99991 16.9906 6.13548 16.4857 6.36811 15.8278L7.51888 10.6575H5.34744C5.23164 10.6575 5.11768 10.6302 5.0159 10.578C4.91412 10.5257 4.82776 10.4503 4.76465 10.3585C4.70154 10.2667 4.66368 10.1615 4.65452 10.0523C4.64536 9.94319 4.66519 9.83362 4.71219 9.73357L7.1548 3.89041Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderExpedited);
export default __webpack_public_path__ + "static/media/order-expedited.409b5affb7ea8583e646bfedc4248f51.svg";
export { ForwardRef as ReactComponent };